import gql from "graphql-tag";

export const CREATE_CRM_CAMPAIGN = gql`
  mutation AddCrmCampaign($data: CrmCampaignDataInput) {
    addCrmCampaign(data: $data) { id name state }
  }
`;

export const UPDATE_CRM_CAMPAIGN = gql`
  mutation UpdateCrmCampaign($where: CrmCampaignWhereInput, $data: CrmCampaignDataInput) {
    updateCrmCampaign(where: $where, data: $data) { id }
  }
`;

export const DELETE_CRM_CAMPAIGN = gql`
  mutation DeleteCrmCampaign($where: CrmCampaignWhereInput) {
    deleteCrmCampaign(where: $where) { id }
  }
`;

const crmCampaigns = { CREATE_CRM_CAMPAIGN, UPDATE_CRM_CAMPAIGN, DELETE_CRM_CAMPAIGN };
export default crmCampaigns;
